import { useCallback, ReactNode } from "react";
import { shallowEqual } from "react-redux";
import { ValidatedFormFieldConfig } from "@evergiving/common/dist/es2015/form";
import {
  getFieldValidationErrors,
  validationContextSelector,
} from "@/lib/misc/validations";
import { useAppSelector } from "@/lib/hooks/redux";

export function useFieldValidationErrors(
  config: ValidatedFormFieldConfig
): { forValue: (value: string | undefined) => ReactNode[] } {
  const validationContext = useAppSelector(
    validationContextSelector,
    shallowEqual
  );
  const forValue = useCallback(
    (value: string | undefined) =>
      getFieldValidationErrors(config, value, validationContext),
    [config, validationContext]
  );

  return { forValue };
}
